import { Grid } from "@mui/material";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { TextInput } from "components/FormControls/TextInput";
import { useMessage } from "hooks/intl";
import { useStyles } from "./styles";

export function RemoveCustomAttribute({ fieldName }: { fieldName: string }) {
  const classes = useStyles();
  const { message } = useMessage();

  return (
    <Grid item xs={6}>
      <TextInput
        className={classes.input}
        data-test-id="effect-attribute-key"
        label={<RequiredFieldLabel text={message({ id: "key" })} />}
        name={`${fieldName}.customAttributeKey`}
      />
    </Grid>
  );
}
